<template>
  <d-container fluid>
    <d-row>
      <d-col class="main-content" tag="main" lg="12" md="12" sm="12">
        <!-- Content -->
        <slot />
      </d-col>

    </d-row>
  </d-container>
</template>

<script>

import MainFooter from '@/components/layout/MainFooter/MainFooter.vue';

export default {
  name: 'login',
  components: {
    MainFooter,
  },
  data() {
    return {
    };
  },
};
</script>

